const a = new URL("../../assets/icon-community-doodi-pancake-swap-gIhX2l7C.png", import.meta.url).href;
export {
  a as default
};
//# sourceMappingURL=icon-community-doodi-pancake-swap.png.js.map
